import { HttpClient } from 'api/http-client';
import { ProjectPhase } from 'api/project';
import { DependentEntityPayload } from 'api/tasks';

export interface UpdateEntityOrderPayload {
  entityId: string;
  position: number;
}

class PhaseAPIClient extends HttpClient {
  public updateEntityOrder = (
    phaseId: number,
    payload: UpdateEntityOrderPayload,
  ): Promise<null> => {
    return this.put(`/phases/${phaseId}/update-entity-order`, payload);
  };

  public getProjectPhase = (phaseId: number): Promise<ProjectPhase> => {
    return this.get(`/phases/${phaseId}`);
  };

  public async createDependentPhase(
    phaseId: number,
    data,
    isSync?: boolean,
    toggleUpdating?: (_value: boolean) => void,
  ): Promise<ProjectPhase> {
    const resp: ProjectPhase = await this.post(
      `/phases/${phaseId}/add-dependency${isSync ? `?isSync=${true}` : ''}`,
      data,
    );

    if (resp && toggleUpdating) {
      toggleUpdating(false);
    }

    return resp;
  }

  public async removeDependentPhase(phaseId: number, data): Promise<boolean> {
    return this.post(`/phases/${phaseId}/remove-dependency`, data);
  }

  public async updateDependentPhases(
    phaseId: number,
    data: DependentEntityPayload[],
    isSync?: boolean,
    toggleUpdating?: (_value: boolean) => void,
  ): Promise<ProjectPhase> {
    const resp: ProjectPhase = await this.post(
      `/phases/${phaseId}/update-dependent-phases${
        isSync ? `?isSync=${true}` : ''
      }`,
      data,
    );

    if (resp && toggleUpdating) {
      toggleUpdating(false);
    }

    return resp;
  }
}

export const PhaseAPI = new PhaseAPIClient();
